export function makeErrorClass<T extends string>(name: T) {
    return class extends Error {
      constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = name;
      }
    };
  }
